export default __webpack_public_path__ + "9bd406f37506910967951d94e450f5e3.svg";